import {
  UserInfoResponse,
  CompanyInfo,
  SetUserInfoAction,
  SetCompanyAction,
  ClearUserInfoAction,
  ClearCompanyAction,
} from '../types/types';

// Action Types
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_COMPANY = 'SET_COMPANY';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';
export const CLEAR_COMPANY = 'CLEAR_COMPANY';

// Action Creators
export const setUserInfo = (userInfo: UserInfoResponse): SetUserInfoAction => ({
  type: SET_USER_INFO,
  payload: userInfo,
});

export const setCompany = (company: CompanyInfo): SetCompanyAction => ({
  type: SET_COMPANY,
  payload: company,
});

export const clearUserInfo = (): ClearUserInfoAction => ({
  type: CLEAR_USER_INFO,
});

export const clearCompany = (): ClearCompanyAction => ({
  type: CLEAR_COMPANY,
});

export type ActionTypes =
  | SetUserInfoAction
  | SetCompanyAction
  | ClearUserInfoAction
  | ClearCompanyAction;
